import { createAsyncThunk } from '@reduxjs/toolkit';

import { searchArticles, SearchArticlesItem } from '../api/searchArticles';
import { HttpClientFactory } from '../httpClient';

export const loadSolutions = createAsyncThunk<
  SearchArticlesItem[],
  {
    query: string;
    limit: number;
    offset: number;
    excludedCategories?: string[];
    httpClient: HttpClientFactory;
  }
>(
  'loadSolutions',
  async ({ query, limit, offset, excludedCategories, httpClient }) => {
    const newArticles = await searchArticles(
      query,
      limit,
      offset,
      httpClient,
      excludedCategories,
    );

    return newArticles;
  },
);
